import 'luxon';

declare global {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    interface Array<T> {
        className(): string;
        paraClassName(): string;
    }
}

Array.prototype.className = function(): string
{
    return this.join(' ');
}

Array.prototype.paraClassName = function(): string
{
    return this.join(' ');
}
